<form class="edit-form" *ngIf="!isLoading" [formGroup]="editForm" (submit)="onSubmit()">
  <section class="form-field">
    <app-autocomplete [control]="getControl('site')" [list]="sites" label="billing.waitingTimes.edit.site.label"
      errorMsg="billing.waitingTimes.edit.site.errorMessage">
    </app-autocomplete>
  </section>

  <mat-form-field>
    <mat-label>{{ 'billing.waitingTimes.edit.minutes.label' | translate }}</mat-label>
    <input type="number" matInput formControlName="minutes">
    <mat-error>{{ 'billing.waitingTimes.edit.minutes.errorMessage' | translate }}</mat-error>
  </mat-form-field>

  <mat-form-field>
    <mat-label>{{ 'billing.waitingTimes.edit.price.label' | translate }}</mat-label>
    <input type="number" matInput formControlName="price">
    <mat-error>{{ 'billing.waitingTimes.edit.price.errorMessage' | translate }}</mat-error>
  </mat-form-field>

  <mat-form-field>
    <mat-label>{{ 'billing.waitingTimes.edit.nonHourlyPrice.label' | translate }}</mat-label>
    <input type="number" matInput formControlName="nonHourlyPrice">
    <!-- <mat-error>{{ 'billing.waitingTimes.edit.nonHourlyPrice.errorMessage' | translate }}</mat-error> -->
  </mat-form-field>

  <app-validate-and-cancel (submitEvent)="endForm($event)" [editForm]="editForm" class="actions"
    [disabling]="editForm.invalid"></app-validate-and-cancel>
</form>

<mat-spinner *ngIf="isLoading" [diameter]="35" color="primary"></mat-spinner>